import { NavigatorScreenParams } from '@react-navigation/native';
import { lazy } from 'react';
import { centerModalOption } from '../appComponents/ModalWrapper';
import { wrapNavigatorScreen } from '../functions/navigation/utils/wrapNavigatorScreen';
import type { WalletFlowScreenParams } from './WalletFlowPage.shared';

const WalletFlowPageContent = lazy(() => import('./WalletFlowPageContent.web'));

const WalletFlowPage = wrapNavigatorScreen(
  (_: NavigatorScreenParams<WalletFlowScreenParams> | {}) => {
    return <WalletFlowPageContent />;
  },
  centerModalOption,
);

export default WalletFlowPage;
